import { render, staticRenderFns } from "./Columns.vue?vue&type=template&id=939e5a6c&"
var script = {}
import style0 from "./Columns.vue?vue&type=style&index=0&id=939e5a6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports